export default __webpack_public_path__ + "static/hp-74acf0b403ae88bbffd0bfc8cd06bf6d.png";